import { ButtonLink } from "ui/components/Button/ButtonLink";
import { useTranslate } from "helpers";
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";


const VehicleHeaderWidget = () => {
    const { t } = useTranslate();

    return (
        <div className="flex items-center gap-2">
            <ButtonLink
                size="small"
                variant="warning"
                children={t("admin.fleet.vehicle.expense.detail")}
                to={FleetVehicleRoutes.FleetVehicleSearchPageRouter}
                startIcon="/media/icons/search.svg"
            />

        </div>
    );
};

export default VehicleHeaderWidget;
